/**
 * Route for `api-driven-report-pull-for-custom-bi-dashboards`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApiDrivenReportPullForCustomBiDashboardsPage } from "../features/api-driven-report-pull-for-custom-bi-dashboards/ApiDrivenReportPullForCustomBiDashboardsPage";

export const apiDrivenReportPullForCustomBiDashboardsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/api-driven-report-pull-for-custom-bi-dashboards",
	component: ApiDrivenReportPullForCustomBiDashboardsPage,
});

export default apiDrivenReportPullForCustomBiDashboardsRoute;
